import { practicalStep, type TourStep } from "./runTour"

/**
 * Walks the "docente ve solo su grupo/semillero a cargo" story
 * (openspec/changes/gestion-panel-user-stories, gestion-teacher-group-tracking)
 * against the real Instructor Hub — which today shows ecosystem-wide stats,
 * not a scoped view, because there's no instructor↔group link in the data
 * model yet. Ends with a real click to the (unscoped) students list, so you
 * can see for yourself that it's not filtered to "my group".
 */
export const teacherGroupTourSteps: TourStep[] = [
  {
    popover: {
      title: 'Tutorial práctico: "Mi grupo" del docente',
      description:
        "Recorre lo que un instructor ve hoy al entrar a su hub, y termina con un clic real que confirma si está o no acotado a su propio grupo.",
    },
  },
  {
    element: '[data-tour="module-metrics"]',
    popover: {
      title: "Métricas del hub",
      description:
        '"Estudiantes activos" y "Progreso promedio" vienen de GET /api/admin/dashboard — el mismo endpoint que ve un admin. No están filtradas por los semilleros o cursos de este instructor en particular.',
      side: "bottom",
    },
  },
  {
    element: '[data-tour="instructor-feed"]',
    popover: {
      title: "Entregas, quizzes y alertas",
      description:
        'Estas tres columnas sí son operativas del día a día del docente, pero tampoco están acotadas a "mi grupo" — "Entregas recientes" lista las últimas entregas de toda la academia.',
      side: "top",
    },
  },
  {
    popover: {
      title: "Lo que falta (gap real)",
      description:
        'No existe ninguna vista "Mi grupo" con la lista de estudiantes de un semillero/grupo específico ni su progreso individual. Tampoco existe el vínculo instructor↔SeedbedGroup en el modelo de datos — sin esa tabla, no hay forma de saber "qué semillero enseña este docente" para poder acotar nada.',
    },
  },
  practicalStep({
    element: '[data-tour="instructor-feed"] a[href^="/instructor/students"]',
    popover: {
      title: "👉 Hazlo tú: confírmalo",
      description:
        'Haz clic en "Ver estudiantes →". Vas a llegar al mismo listado completo de estudiantes que ve un admin — ninguno filtrado a tu grupo. Esa es la prueba en vivo del gap.',
      side: "top",
    },
  }),
]
